import { createContext, useContext, useEffect, useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router';

export const LayoutContext = createContext(null);

export const useLayoutContext = () => {
  return useContext(LayoutContext);
};

function useQuery() {
  return queryString.parse(useLocation().search);
}

export const LayoutContextProvider = ({ children }) => {
  const [showNavBar, setShowNavBar] = useState(false);
  const { nav } = useQuery();

  useEffect(() => {
    let hideNavBar = nav ? nav.toLowerCase() : undefined;
    if (!hideNavBar) {
      const storedHidNavBar = localStorage.getItem('hideNavBar');
      if (storedHidNavBar) {
        hideNavBar = storedHidNavBar;
      }
    }
    localStorage.setItem('hideNavBar', hideNavBar);
    setShowNavBar(!hideNavBar || hideNavBar !== 'hide');
  }, [nav]);
  return (
    <LayoutContext.Provider value={{ showNavBar }}>
      {children}
    </LayoutContext.Provider>
  );
};
